import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";
const API_V2_URL = `${API_BASE_URL}/v2`;

export interface LogCollectorConfig {
  id: number;
  scopeType: "global" | "tenant" | "reflector";
  scopeId: string | null;
  fluentBitConf: string | null;
  ctxrLua: string | null;
  contentHash: string | null;
  label: string | null;
  createdBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateConfigPayload {
  scopeType: "global" | "tenant" | "reflector";
  scopeId?: string;
  fluentBitConf?: string;
  ctxrLua?: string;
  label?: string;
}

export interface PublishTargets {
  ctxrUuids?: string[];
}

export interface FetchCurrentResult {
  requestId: string;
  ctxrUuid: string;
  fluentBitConf: string | null;
  ctxrLua: string | null;
  respondedAt: string | null;
}

export function getConfigs(token: string) {
  return axios.get<{ success: boolean; data: LogCollectorConfig[] }>(
    `${API_V2_URL}/reflector-admin/log-collector-config`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
}

export function getConfigById(id: number, token: string) {
  return axios.get<{ success: boolean; data: LogCollectorConfig }>(
    `${API_V2_URL}/reflector-admin/log-collector-config/${id}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
}

export function createConfig(data: CreateConfigPayload, token: string) {
  return axios.post<{ success: boolean; data: LogCollectorConfig }>(
    `${API_V2_URL}/reflector-admin/log-collector-config`,
    data,
    { headers: { Authorization: `Bearer ${token}` } }
  );
}

export function updateConfig(
  id: number,
  data: Partial<CreateConfigPayload>,
  token: string
) {
  return axios.put<{ success: boolean; data: LogCollectorConfig }>(
    `${API_V2_URL}/reflector-admin/log-collector-config/${id}`,
    data,
    { headers: { Authorization: `Bearer ${token}` } }
  );
}

export function deleteConfig(id: number, token: string) {
  return axios.delete<{ success: boolean }>(
    `${API_V2_URL}/reflector-admin/log-collector-config/${id}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
}

export function publishConfig(
  id: number,
  targets: PublishTargets,
  token: string
) {
  return axios.post<{ success: boolean; data: { published: string[]; failed: string[] } }>(
    `${API_V2_URL}/reflector-admin/log-collector-config/${id}/publish`,
    targets,
    { headers: { Authorization: `Bearer ${token}` } }
  );
}

export function fetchCurrentConfig(ctxrUuid: string, token: string) {
  return axios.post<{ success: boolean; data: FetchCurrentResult }>(
    `${API_V2_URL}/reflector-admin/log-collector-config/fetch`,
    { ctxrUuid },
    { headers: { Authorization: `Bearer ${token}` } }
  );
}
